
// Environment configuration
type Environment = 'development' | 'staging' | 'production';

// Get the current environment from Vite's import.meta.env
// Default to 'development' if not specified
export const getCurrentEnvironment = (): Environment => {
  const envMode = import.meta.env.MODE || 'development';
  
  if (envMode === 'staging') return 'staging';
  if (envMode === 'production') return 'production';
  return 'development';
};

// Base configuration that applies to all environments
const baseConfig = {
  // Common config values here
};

// Environment-specific configurations
const environmentConfigs = {
  development: {
    ...baseConfig,
    apiUrl: 'http://localhost:8080',
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL || 'https://fmuvniyvftmenrgeywtv.supabase.co',
    supabaseKey: import.meta.env.VITE_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZtdXZuaXl2ZnRtZW5yZ2V5d3R2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNzQ3MjAsImV4cCI6MjA1Njk1MDcyMH0.vXIVGA-mEmAepek1_oJhFZPrNh4CwRSInfpp9tCke2Y',
    isStaging: false,
    debugMode: true,
  },
  staging: {
    ...baseConfig,
    apiUrl: 'https://staging-api.yourdomain.com',
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseKey: import.meta.env.VITE_SUPABASE_KEY,
    isStaging: true,
    debugMode: true,
  },
  production: {
    ...baseConfig,
    apiUrl: 'https://api.yourdomain.com',
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL || 'https://fmuvniyvftmenrgeywtv.supabase.co',
    supabaseKey: import.meta.env.VITE_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZtdXZuaXl2ZnRtZW5yZ2V5d3R2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNzQ3MjAsImV4cCI6MjA1Njk1MDcyMH0.vXIVGA-mEmAepek1_oJhFZPrNh4CwRSInfpp9tCke2Y',
    isStaging: false,
    debugMode: false,
  },
};

// Main config function that returns the appropriate configuration
export const getConfig = () => {
  const environment = getCurrentEnvironment();
  return environmentConfigs[environment];
};

// Helper function to indicate if we're running in staging mode
export const isStaging = () => getCurrentEnvironment() === 'staging';

// Helper function to indicate if we're running in development mode
export const isDevelopment = () => getCurrentEnvironment() === 'development';

// Helper function to indicate if we're running in production mode
export const isProduction = () => getCurrentEnvironment() === 'production';
